import { SVGFC } from '@repo/toolkit/types'

const MinusIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.59998 12.6001H16.3999C16.7314 12.6001 17 12.3315 17 12C17 11.6685 16.7315 11.3999 16.3999 11.3999H7.59998C7.26863 11.4 7 11.6686 7 12C7 12.3315 7.26863 12.6001 7.59998 12.6001Z"
        fill={color}
      />
    </svg>
  )
}

export default MinusIcon
